import React from 'react';
import Icon from '../icon';
import styles from './style.less';

export interface SidebarProps {
  onClose: () => void
}

const Sidebar: React.FC<SidebarProps> = ({ children, onClose }) => {
  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarHandle} onClick={onClose}>
        <div className={styles.sidebarHandleClose}>
          <Icon type="close" size={30} color="#fff" />
        </div>
      </div>
      <div className={styles.sidebarContent}>
        {children}
      </div>
    </div>
  )
};

export default Sidebar;